module.exports = __webpack_public_path__ + "static/media/oval.a9842492.svg";